// extracted by mini-css-extract-plugin
export default {"actions":"analysisReport_actions__taZ80","container":"analysisReport_container__NfY4I","title":"analysisReport_title__nqmlm"};